import ReactECharts from "echarts-for-react";
import { useTranslation } from "react-i18next";

interface CardProps {
    title: string;
    value: number | string;
    change: number; // % thay đổi
    extra?: number | string; // số +/- phía dưới
    comparedText: string;
}

const Card = ({ title, value, change, extra, comparedText }: CardProps) => {
    const isUp = change > 0;

    const option = {
        grid: { top: 0, bottom: 0, left: 0, right: 0 },

        tooltip: {
            trigger: "axis", // 👈 cần để hover hoạt động
        },

        xAxis: {
            type: "category",
            show: false,
            boundaryGap: false,
            data: ["1", "2", "3", "4", "5", "6", "7"],
        },

        yAxis: {
            type: "value",
            show: false,
        },

        series: [
            {
                type: "line",
                data: [1, 1, 1, 1, 1, 10, 1],
                smooth: false,

                symbol: "circle",
                symbolSize: 6,

                showSymbol: false, // ❗ chỉ hiện khi hover

                emphasis: {
                    focus: "series",
                    itemStyle: {
                        color: isUp ? "#16a34a" : "#ef4444",
                        borderWidth: 2,
                        borderColor: "#fff",
                    },
                },

                lineStyle: {
                    width: 1.5,
                    color: isUp ? "#16a34a" : "#ef4444",
                },
            },
        ],
    };

    return (
        <div className="bg-white dark:bg-[#1f1f1f] p-4 rounded-xl flex justify-between items-center border border-gray-200 dark:border-[#2a2a2a]">

            {/* LEFT */}
            <div className="space-y-1">
                <p className="text-gray-500 text-sm text-000000e0">{title}</p>

                <div className="flex items-center gap-2">
                    <h2 className="text-xl font-semibold text-000000e0">{value}</h2>

                    {/* Badge */}
                    <span
                        className={`text-xs px-2 py-[2px] rounded-md font-medium
                            ${isUp
                                ? "bg-green-100 text-green-600"
                                : "bg-red-100 text-red-500"
                            }`}
                    >
                        {isUp ? "↑" : "↓"} {Math.abs(change)}%
                    </span>
                </div>

                {/* Sub text */}
                <p className="text-sm !mt-3">
                    <span
                        className={`font-medium ${isUp ? "text-green-600" : "text-red-500"
                            }`}
                    >
                        {extra}
                    </span>{" "}
                    <span className="text-gray-400 text-[12px]">{comparedText}</span>
                </p>
            </div>

            {/* RIGHT CHART */}
            <ReactECharts option={option} style={{ width: 80, height: 40 }} />
        </div>
    );
};

const StatsBar = () => {
    const { t } = useTranslation();
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Card title={t("lead.stats_new_leads")} value={45} change={-49} extra={-43} comparedText={t("lead.compared_to_last_month")} />
            <Card title={t("lead.stats_new_phones")} value={151} change={100} extra={151} comparedText={t("lead.compared_to_last_month")} />
            <Card title={t("lead.stats_converted_leads")} value={8} change={-47} extra={-7} comparedText={t("lead.compared_to_last_month")} />
            <Card title={t("lead.stats_conversion_rate")} value="17.78" change={4} extra={0.73} comparedText={t("lead.compared_to_last_month")} />
        </div>
    );
};

export default StatsBar;